import React from 'react'
import LoginComponent from '../../Components/LoginComponent/LoginComponent'
import Footer from '../../Components/Footer/Footer'
import Header from '../../Components/Header/Header'
// import { NilCollaborationForm } from '../../Components/NilCollaborationForm/NilCollaborationForm'

const Login = () => {
    return (
        <div>
            <Header />
            {/* <NilCollaborationForm /> */}
            <LoginComponent />
            <Footer />
        </div>
    )
}
export default Login